import styled from 'styled-components';

export const Styled = styled.div`
    

        label {
            padding-right: 10px;
            font-size: 18px;
            max-width: 500px;
        }
 
        margin: 0;


        .validate-error {
            .dropdown-autocomplete {
                border: 1px solid red;
            }
        }

        .dropdown-autocomplete {
            background-color: #202024;
            font-size: 16px;
            border: 0px;
            margin-top: 8px;
            cursor: pointer;

            div {
                background-color: #202024;
                color: #fff;
            }
            > div > div {
                [class$="placeholder"] {
                    color: #757575;
                }
            }


            input { position: relative; z-index: 2; margin-bottom: 5px;}
        }
    
`;

export const selectAutocompleteStyles = {
    control: ( baseStyles, state) => ({
        ...baseStyles,
        height: '60px',
        border: state.menuIsOpen ? 0 : state.isFocused ? '2px solid #fff' : 0,
        boxShadow: 'none',
        cursor: 'pointer',
        overflowY: 'clip'
        
    }),
    valueContainer: (baseStyles, state) => ({
        ...baseStyles,
        height: '60px',
        overflowY: 'clip'
    }),
    placeholder: (baseStyles, state) => ({
        ...baseStyles,
        color: '#757575',
        paddingTop: '10px',
        paddingLeft: '5px',
        top: '45%',
        opacity: 0.8
    }),
    indicatorSeparator: (baseStyles, state) => ({
        ...baseStyles,
        display: 'none'
    }),
    indicatorContainer: (baseStyles, state) => ({
        ...baseStyles,
        display: 'none'
    }),
    menu: (baseStyles, state) => ({
        ...baseStyles,
        marginTop: 'none'
    }),
    multiValueLabel: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: '#303034 !important'
    }),
    multiValueRemove: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: '#303034 !important'
    }),
    input: (baseStyles, state) => ({
        ...baseStyles,
        'input:focus': {
            height: '0'
        },
        'input:not(:placeholder-shown)': {
            height: '20px'
        }
    }),
    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
        // const color = chroma(data.color);
        return {
            ...styles,
            background: isSelected
                ? '#404044 !important'
                : isFocused
                ? '#303034 !important'
                : undefined,
            color: isSelected ? '#fff' : '#000',
            cursor: 'pointer'
        };
    }
};